document.addEventListener("DOMContentLoaded", function () {
  const carousel = document.getElementById("carousel-boxes");

  if (!carousel) return;

  const prevBtn = document.getElementById("prev");
  const nextBtn = document.getElementById("next");
  const indicators = document.getElementById("indicators").children;

  const totalSlides = carousel.children.length;
  let index = 0;

  function moveToSlide(i) {
    carousel.style.transform = `translateX(-${i * 100}%)`;
    updateIndicators(i);
    updateButtons(i);
  }

  function updateIndicators(i) {
    for (let j = 0; j < indicators.length; j++) {
      indicators[j].classList.toggle("p-bg-primary", j === i);
      indicators[j].classList.toggle("p-bg-light", j !== i);
    }
  }

  function updateButtons(i) {
    prevBtn.classList.toggle("p-hidden", i === 0);
    nextBtn.classList.toggle("p-hidden", i === totalSlides - 1);
  }

  nextBtn.addEventListener("click", () => {
    if (index < totalSlides - 1) {
      index++;
      moveToSlide(index);
    }
  });

  prevBtn.addEventListener("click", () => {
    if (index > 0) {
      index--;
      moveToSlide(index);
    }
  });

  Array.from(indicators).forEach((dot, i) => {
    dot.addEventListener("click", () => {
      index = i;
      moveToSlide(index);
    });
  });

  moveToSlide(index);
});
